import { queryClient } from '@shared/api/reactQuery';
import { getPostDocApiReportAccountsMonthlyMutationOptions } from '@shared/api/docService/report/accounts/monthly';
import { getPostApiAccountReportsIdMonthlyFormDataMutationOptions } from '@/shared/api/orval/account-reports/account-reports';

export interface PreviewReport {
  getPreviewUrl: (reportId: number) => Promise<string | null>;
}

export const PreviewReportIdentifier = Symbol.for('PreviewReport');

export class PreviewReportImpl implements PreviewReport {
  getPreviewUrl = async (reportId: number) => {
    try {
      const rawReportHtml = await this.getReportHtml(reportId);
      const reportHtml = this.createPreview(rawReportHtml);
      const blob = new Blob([reportHtml], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      return url;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  private getReportHtml = async (reportId: number) => {
    const formDataResponse = await queryClient
      .getMutationCache()
      .build(queryClient, getPostApiAccountReportsIdMonthlyFormDataMutationOptions())
      .execute({
        id: reportId,
        data: {}
      });

    if (formDataResponse.code !== 0 || !formDataResponse?.result) {
      throw new Error(formDataResponse?.message ?? 'common:unknownError');
    }

    const reportResponse = await queryClient
      .getMutationCache()
      .build(queryClient, getPostDocApiReportAccountsMonthlyMutationOptions())
      .execute({ payload: formDataResponse.result });

    const binary = atob(reportResponse.data.docBase64);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    const html = new TextDecoder('utf-8').decode(bytes);

    return html;
  };

  private createPreview = (html: string) => {
    /** TODO:
     * - перенести логику в ежемесячные отчеты
     * - уточнить насчет реализации ежегодных отчетов
     * */
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    doc.head.append(this.getStyle());

    const preview = `<!DOCTYPE html>\n${doc.documentElement.outerHTML}`;

    return preview;
  };

  private getStyle = () => {
    const style = document.createElement('style');
    style.textContent = `
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}`;

    return style;
  };
}
